import CardService from 'components/CardService';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Creators as FormCreators } from '../../store/ducks/serviceForm';

import {
  Container,
  MoreService,
} from './styles';

function ServicesMost() {
  const dispatch = useDispatch();

  const [showAll, setShowAll] = useState(false);
  const companySource = useSelector(state => state.company.data.source);
  const companyId = useSelector(state => state.company.data.id);
  const services = useSelector(state => state.services.data);
  const servicesOthers = services.length && services.filter(
    (service, id) => id > 8 && (showAll || id <= 16),
  );

  const textMore = !showAll ? 'Veja mais serviços' : 'Veja menos serviços';

  function _openServiceForm(payload) {
    dispatch(FormCreators.openForm(payload));
  }

  return (
    <Container>
      {
        servicesOthers && servicesOthers.length && servicesOthers.map(service => (
          <CardService
            key={`service-others-${service.id}`}
            service={service}
            openForm={() => _openServiceForm({
              open: true,
              isOpen: true,
              source: companySource,
              company_id: companyId,
              serviceId: service.id,
            })
            }
          />
        ))
      }
      <MoreService primary onClick={() => setShowAll(!showAll)}>{textMore}</MoreService>
    </Container>
  );
}

export default ServicesMost;
